import { FAKE, inject, REAL, registerDependency } from '@cloudsuite/mosaic-shared/scripts/dependency-injection.js'
import {
  PRODUCT_INFORMATION_FETCHER,
  ProductInformationFetcher
} from 'components/ordering/stores/product/search-product-api.js'
import { parseProductList } from 'components/ordering/backorders/typing/product-list.js'
import { createSignal } from '@cloudsuite/mosaic-shared/scripts/signals.js'

export interface ProductInfo {
  img_url: string
  name: string
  code: string | null
  ean: string | null
}

export const SEARCH_PRODUCT_STORE = Symbol('SEARCH_PRODUCT_STORE')

@registerDependency(REAL, SEARCH_PRODUCT_STORE)
@registerDependency(FAKE, SEARCH_PRODUCT_STORE)
export class SearchProductStore {
  @inject(PRODUCT_INFORMATION_FETCHER)
  productInformationFetcher!: ProductInformationFetcher

  private headlessEndpoint!: string

  initialize = (headlessEndpoint: string) => {
    this.headlessEndpoint = headlessEndpoint
  }

  products: () => Map<number, ProductInfo>
  private setProducts: (value: Map<number, ProductInfo>) => void

  constructor() {
    [this.products, this.setProducts] = createSignal(new Map<number, ProductInfo>())
  }
  parseProducts = (products: Record<number, any>) => {
    const productList = parseProductList(products)
    const productsMap = new Map([
      ...this.products().entries(),
    ])
    productList.forEach(product => {
      productsMap.set(product.id, {
        img_url: product.picture.small,
        name: product.name,
        code: product.code,
        ean: product.code_ean
      })
    })
    this.setProducts(productsMap)
  }

  getProducts = async (ids: number[]): Promise<Map<number, ProductInfo>> => {
    if (this.headlessEndpoint === undefined) {
      throw new Error('SearchProductStore not properly initialized')
    }
    const productIds = ids.reduce((cum, cur) => {
      if (!this.products().has(cur)) {
        cum.add(cur)
      }
      return cum
    }, new Set<number>())
    if (productIds.size > 0) {
      const request = this.productInformationFetcher.getProductInformation(productIds.values().toArray(), this.headlessEndpoint)

      const responseProducts = await request
      const products: Record<number, any> = {}
      responseProducts?.forEach((response) => {
        products[response.id] = response
      })

      this.parseProducts(products)
    }

    return this.products()
  }
}
